import { render, staticRenderFns } from "./NumberCell.vue?vue&type=template&id=c277573c&scoped=true&"
import script from "./NumberCell.vue?vue&type=script&setup=true&lang=ts&"
export * from "./NumberCell.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./NumberCell.vue?vue&type=style&index=0&id=c277573c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c277573c",
  null
  
)

export default component.exports